module.exports = __webpack_public_path__ + "plat/static/img/grid.ca50deb6.svg";